export const DEVIS_ACHAT = {
  titre: 'Liste des devis d\'achat',
  voirDevisAchat: 'Voir les devis d\'achat',
  actionGroupee: {
    telecharger: 'Edition en zip',
  },
  etat: {
    brouillon: 'Brouillon',
    enregistre: 'Enregistré',
    sansSuite: 'Sans suite',
  },
  columns: {
    code: 'Code devis achat',
    referenceHavas: 'Référence HAVAS',
    etat: 'État',
    fournisseur: 'Fournisseur',
    date: 'Date',
    montantHt: 'Montant HT',
    editer: 'Éditer',
    envoyerEmail: 'Envoyer par email',
  },
  messages: {
    selectionVide: 'Veuillez sélectionner au moins un devis',
    zipSuccess: '{nb} devis téléchargé(s) avec succès',
  },
  mail: {
    objet: 'Devis {codeDevis}',
    titre: 'Envoyer le devis par email',
  },
};